let DataFetcher;
if (process.env.isClient) {
  DataFetcher = require('./ClientDataFetcher').default;
} else {
  DataFetcher = require('./ServerDataFetcher').default;
}

export default DataFetcher;
